/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Contact_Phone_ExistsInputs */

const en_case_contact_phone_exists = /** @type {(inputs: Case_Contact_Phone_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A contact with this phone number already exists in this case.`)
};

const pt_br2_case_contact_phone_exists = /** @type {(inputs: Case_Contact_Phone_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Já existe um contato com este número de telefone neste caso.`)
};

/**
* | output |
* | --- |
* | "A contact with this phone number already exists in this case." |
*
* @param {Case_Contact_Phone_ExistsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_contact_phone_exists = /** @type {((inputs?: Case_Contact_Phone_ExistsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Contact_Phone_ExistsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_contact_phone_exists(inputs)
	return pt_br2_case_contact_phone_exists(inputs)
});